// removed by extract-text-webpack-plugin
module.exports = {"mbr-card-container":"MembershipCard--mbr-card-container--2AhoUjPD","mbrCardContainer":"MembershipCard--mbr-card-container--2AhoUjPD","mbr-card-canvas":"MembershipCard--mbr-card-canvas--1hw6rjr2","mbrCardCanvas":"MembershipCard--mbr-card-canvas--1hw6rjr2","mbr-card-svg":"MembershipCard--mbr-card-svg--2_CGeqjU","mbrCardSvg":"MembershipCard--mbr-card-svg--2_CGeqjU"};


//////////////////
// WEBPACK FOOTER
// ./src/App/account/components/MembershipCard/MembershipCard.css
// module id = 1275
// module chunks = 2